module.exports = __webpack_public_path__ + "media/images/forms-icons/bmi-icon-bcdbcdd882c98fd0f4cb7c528ffdd305.svg";